const workflowAction = {
  showModal({ commit }, { params, tag, status }) {
    commit("setModalData", { params, tag, status });
  },
  setAuthModal({ commit }, { params, status }) {
    commit("setAuthModal", { params, status });
  },
  saveGroups({ commit }, groups) {
    commit("setGroups", groups)
  },
  saveWorkflows({ commit }, workflows) {
    commit("setWorkflows", workflows)
  },
  saveWorkflow({ commit, state }, workflow) {
    commit("setWorkflow", {
      workCode: state.workflowCode,
      groupCode: workflow.groupCode,
      schema: JSON.parse(workflow.workflowSchema),
      workflow: JSON.parse(workflow.workflowSchema),
    });
  },
  saveAllApis({ commit }, apis) {
    var reApis = [];
    for (var i = 0; i < apis.length; i++) {
      var ver = JSON.parse(apis[i].apiSchema).versionCode;
      reApis.push({
        apiCode: apis[i].apiCode,
        apiName: apis[i].apiName,
        versionCode: ver,
      });
    }

    commit("setApis", reApis);

  },
  saveApps({ commit }, apps) {
    commit("setApps", apps);
  },
  saveWorkflowDetailHistory({ commit }, history) {
    commit("setWorkflowDetailHistory", history);
  },
  saveWorkflowDetailHistorys({ commit }, historys) {
    commit("setWorkflowDetailHistorys", historys);
  },
  saveConnections({ commit }, connections) {
    commit("setConnections", connections);
  },
  saveApiHistorys({ commit }, historys) {
    commit("setApiHistorys", historys);
  },
  getGroupList({ commit }, { groups }) {
    // const res = await dispatch("postSend", { paths: paths, params: params });

    commit("setGroups", groups);

  },

  getWorkflowList({ commit, dispatch }, { paths, params }) {
    dispatch("postSend", { paths: paths, params: params })
      .then((res) => {
        commit("setWorkflows", res.workflows);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  getAppList({ commit, dispatch }, { paths, params }) {
    dispatch("postSend", { paths: paths, params: params })
      .then((res) => {
        commit("setApps", res.app);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  async getApiList({ dispatch }, { paths, params }) {
    const res = await dispatch("postSend", { paths: paths, params: params });

    var apis = res.apis;
    console.log(apis)
    var triggers = [];
    var actions = [];
    var auths = [];

    if (res.code == 0) {
      for (var i = 0; i < apis.length; i++) {
        if (apis[i].apiType == "trigger") {
          triggers.push(apis[i]);
        } else if (apis[i].apiType == "action") {
          actions.push(apis[i]);
        } else if(apis[i].apiType == "authentication") {
          auths.push(apis[i]);
        }
      }

      return { apis: apis, triggers: triggers, actions: actions, auths: auths };
    }
  },

  getAppDetail({ commit, dispatch }, { paths, params }) {
    dispatch("postSend", { paths: paths, params: params })
      .then((res) => {
        commit("setApp", res.app);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  async getApiDetail({ commit, dispatch }, { paths, params, index }) {
    const res = await dispatch("postSend", { paths: paths, params: params });
    commit("setApi", { api: res.api, index: index });

    return res.api;
  },

  async getWorkflowDetail({ commit, dispatch }, { paths, params }) {
    const res = await dispatch("postSend", { paths: paths, params: params });
    commit("setWorkflow", {
      workCode: params.workflowCode,
      groupCode: res.workflow.groupCode,
      schema: JSON.parse(res.workflow.workflowSchema),
      workflow: JSON.parse(res.workflow.workflowSchema),
    });

    return 1;
  },

  saveData({ commit }, { params, tag }) {
    if (tag == "app") {
      commit("setAppInfo", params);
    }
  },

  buildWorkflows({ commit }, obj) {
    commit("setBuildWorkflows", obj);
  },

  addAction({ commit }, obj) {
    commit("setBuildWorkflows", obj);
  },
  buildAppNames({ commit }, names) {
    commit("setBuildAppNames", names);
  },
  changeApp({ commit, dispatch }, { paths, params, index }) {
    dispatch("postSend", { paths: paths, params: params })
      .then((res) => {
        commit("setChangeApp", { app: res.app, index: index });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getSourceTriggerApi({ commit, dispatch }, { paths, params }) {
    dispatch("postSend", { paths: paths, params: params })
      .then((res) => {
        commit("setSourceTriggerSchema", res.api);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  // async getAllApiList({ commit, dispatch }, { paths, params }) {
  //   const res = await dispatch("postSend", { paths: paths, params: params });
  //
  //   var apis = [];
  //   for (var i = 0; i < res.apis.length; i++) {
  //     var ver = JSON.parse(res.apis[i].apiSchema).versionCode;
  //     apis.push({
  //       apiCode: res.apis[i].apiCode,
  //       apiName: res.apis[i].apiName,
  //       versionCode: ver,
  //     });
  //   }
  //
  //   commit("setApis", apis);
  //
  //   return apis;
  // },
  changeNowWorkName({ commit }, name) {
    commit("setNowWorkName", name);
  },
  changeNowWorkCode({ commit }, code) {
    commit("setWorkCode", code);
  },
  changeWorkflowName({ commit }, name) {
    commit("setWorkflowName", name);
  },
  resetState({ commit }, { params, tag }) {
    commit("setResetData", { params, tag });
  },
  saveApis({ commit }, apis) {
    commit("setApis", apis);
  },
  saveGroupCode({ commit }, code) {
    console.log("야ㅕㄱ;ㅣ")
    commit("setGroupCode", code);
  },
  saveResponse({ commit }, params) {
    commit("setResponse", params)
  },
  saveWorkflowCode({ commit }, code) {
    commit("setWorkflowCode", code)
  },
  saveWorkflowForm({ commit }, form) {
    commit("setWorkflowForm", form)
  }
};

export default workflowAction;
